import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Box from "@material-ui/core/Box";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

export default class ComponentToPrint extends React.Component {
    render() {
        const tableData = this.props.tableData;
        const Group = this.props.groups;
        const Estate = this.props.estates;
        const Division = this.props.division;
        const monthlyCollectionDetails = this.props.monthlyCollectionDetails;
        const sessionHeaders = this.props.sessionHeaders;
        const chipData = this.props.chipData;
        return (
            <div>
                <h3><center><u>Employee 360 Report </u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {Group}</div>
                    <div className="col"><b>Operation Entity: </b> {Estate}</div>
                    <div className="col"><b>Collection Point: </b> {Division}</div>
                    <div className="col"><b>From :</b> {new Date(monthlyCollectionDetails.fromDate).toLocaleDateString()}</div>
                    <div className="col"> <b>To :</b> {new Date(monthlyCollectionDetails.toDate).toLocaleDateString()}</div>
                    <div className="col"><b>Registartion Number: </b> {monthlyCollectionDetails.regNumber}</div>
                </div>
                <div className="col-12" style={{ paddingBottom: '10px' }}>
                    <h6>Employee last transaction date</h6>
                    <Stack direction="row" spacing={2}>
                        {chipData[0] && (
                            <Chip
                                label={`Plucking : ${chipData[0]}`}
                                variant="outlined"
                                size="small"
                                sx={{
                                    borderColor: "limegreen",
                                    color: "limegreen",
                                    fontWeight: "bold",
                                }}
                            />
                        )}
                        {chipData[1] && (
                            <Chip
                                label={`Sundry : ${chipData[1]}`}
                                variant="outlined"
                                size="small"
                                sx={{
                                    borderColor: "limegreen",
                                    color: "limegreen",
                                    fontWeight: "bold",
                                }}
                            />
                        )}
                    </Stack>
                </div>
                <div className="col-md-12">
                    <Box display="flex" justifyContent="flex-end" >
                        <TableContainer component={Paper} >
                            <Table able size="small" >
                                <TableHead style={{ textAlign: 'center', top: 0, background: 'white' }}>
                                    <TableRow style={{ border: '2px solid black' }}>
                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Date</TableCell>
                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Emp.Name</TableCell>
                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Emp.Type</TableCell>
                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Work Division</TableCell>
                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>InTime</TableCell>
                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>OutTime</TableCell>
                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Job Type</TableCell>
                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Job Code</TableCell>
                                        <TableCell colSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Session W1</TableCell>
                                        <TableCell colSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Session W2</TableCell>
                                        <TableCell colSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>Session W3</TableCell>
                                        <TableCell rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>OT Hours</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: '2px solid black' }}>
                                        {sessionHeaders.map((data, index) => (
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'center' }}>
                                                {data.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    {tableData.map((data, dataIndex) => (
                                        <TableRow key={dataIndex} style={{ border: '2px solid black' }}>
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                {new Date(data.date).toLocaleDateString()}
                                            </TableCell>
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                {data.employeeName}
                                            </TableCell>
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                {data.employeeTypeName}
                                            </TableCell>
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                {data.divisionName === undefined ? '-' : data.divisionName}
                                            </TableCell>
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                {data.inTime}
                                            </TableCell>
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                {data.outTime}
                                            </TableCell>
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                {data.jobType === "1" ? 'General' : data.jobType === "2" ? 'Cash' : data.jobType == 'RSM' ? 'Outgrower' : data.jobType}
                                            </TableCell>
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                {data.jobCode === null ? '-' : data.jobCode}
                                            </TableCell>
                                            {sessionHeaders.map((column) => {
                                                const length = column.value.substr(column.value.length - 1);
                                                const value = data[column.value];
                                                if (length == "Q") {
                                                    return (
                                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'right' }}>
                                                            {value == undefined ? '-' : value == 0 ? '-' : parseInt(value)}
                                                        </TableCell>
                                                    );
                                                }
                                                else {
                                                    return (
                                                        <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'left' }}>
                                                            {value == undefined ? '-' : value == 0 ? '-' : (value)}
                                                        </TableCell>
                                                    );
                                                }
                                            })}
                                            <TableCell style={{ border: '2px solid black', fontWeight: 'bold', textAlign: 'right' }}>
                                                {data.otHours}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
            </div>
        );
    }
}